const HAS_DOCS = 'HAS_DOCS';

const JobFlags = {
    HAS_DOCS
};

export { JobFlags };